module.exports = __webpack_public_path__ + "img/d753667.jpg";